import React from 'react';
import './Process.css';
import useScrollReveal from '../hooks/useScrollReveal';

const steps = [
  {
    number: 'I',
    title: 'Analysieren & Dokumentieren',
    description: 'Wir starten mit einer individuellen Beratung und einer detaillierten Analyse Ihrer Geschäftsprozesse. Dabei erfassen und dokumentieren wir systematisch Abläufe, Engpässe und Potenziale – als Grundlage für fundierte Entscheidungen und nachhaltige Optimierung.'
  },
  {
    number: 'II',
    title: 'Entdecken & Optimieren',
    description: 'Anschließend identifizieren wir die Aufgaben mit dem höchsten Optimierungspotenzial und entwickeln einen maßgeschneiderten Umsetzungsplan. Mittels Automatisierung, Business-Intelligence-Lösungen und KI-Agenten, die wiederkehrende Aufgaben effizient übernehmen, implementieren wir modernste IT-Lösungen in Ihrem Unternehmen.'
  },
  {
    number: 'III',
    title: 'Wachsen & Zukunft sichern',
    description: 'Das Ergebnis ist eine automatisierte Organisation, die Wissen speichert, Prozesse optimiert und so Ihr Wachstum und Ihre Widerstandsfähigkeit über Generationen hinweg sichert. Ihr Team gewinnt Zeit für strategische und wertschöpfende Aufgaben zurück.'
  }
];

function Process() {
  const headerRef = useScrollReveal();
  const stepsRef = useScrollReveal(true);

  return (
    <section id="process" className="process">
      <div className="section-container">
        <div ref={headerRef} className="reveal">
          <h2 className="section-title">Gemeinsam meistern wir diese Herausforderungen</h2>
          <p className="section-subtitle">
            Dies ist der Weg, den wir gemeinsam gehen, um Ihr Unternehmen zukunftssicher zu gestalten:
          </p>
        </div>

        <div ref={stepsRef} className="process-steps">
          {steps.map((step, index) => (
            <div key={index} className="process-step" data-reveal>
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
